export default __webpack_public_path__ + "static/media/icon_twitter.e1f2d385.svg";